module.exports = __webpack_public_path__ + "img/layout_right_3.5b704c17.png";